import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { getProducts, addProductMedia } from '../../store/features/groupsSlice';
import { ReactComponent as LoadingIcon } from '../../assets/images/loading.svg';
import { ReactComponent as DeleteIcon } from '../../assets/images/trash-red.svg';

import { addToast } from '../../store/features/toastSlice';
import DropDown from '../../components/McDropdown';
import Button from '../../components/Elements/button/button';
import { uploadMedia } from '../../store/services/media';

const ProductMedia = () => {
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState();
  const [search, setSearch] = useState('');
  const [uploadingImage, setUploadingImage] = useState(false);
  const [file, setFile] = useState(false);

  const pageRef = useRef(null);
  const inputRef = useRef(null);

  const { products } = useSelector(state => state.groups);

  useEffect(() => {
    fetchProducts(0, false);
  }, [search]);

  const fetchProducts = (page, merge) => {
    dispatch(getProducts({ merge: merge, params: { page: page, search: search }, url: '' }));
  };

  const onUpload = async file => {
    if (file) {
      try {
        setUploadingImage(true);
        const imageData = await uploadMedia(file);
        setFile({
          id: imageData?.media_external_id,
          image: { url: imageData.url },
          name: file.name,
          size: file.size,
        });
        setUploadingImage(false);
        inputRef.current.value = '';
      } catch (error) {
        console.log(error);
        dispatch(addToast({ error: true, text: 'Error while uploading file' }));
        setUploadingImage(false);
        inputRef.current.value = '';
      }
    }
  };

  const onSave = async () => {
    setFile(null);
    setSelectedProduct(null);
    await dispatch(
      addProductMedia({
        id: selectedProduct.id,
        body: { media: { id: file.id }, product_media_type: 'SPECIFICATION' },
      }),
    );
    dispatch(addToast({ error: false, text: 'Product media added' }));
  };

  return (
    <ProductMediaWrapper>
      <div className="flex flex-1">
        <div className="flex-column flex-1 pxy-4" style={{ maxWidth: '500px' }}>
          <DropDown
            options={products?.content}
            selected={selectedProduct}
            setSelected={setSelectedProduct}
            placeholder={'Select product'}
            hasMore={!products?.last}
            isPaged={true}
            isSearchable={true}
            search={search}
            setSearch={setSearch}
            fetchData={() => fetchProducts(pageRef.current + 1, true)}
          />
          {file ? (
            <div className="flex mt-6">
              <div className="flex-column flex-1">
                {file && <label className="regular-text">{file.name}</label>}
                {file.size && (
                  <label className="regular-text grey-text">{`${parseFloat(parseInt(file.size) / 1024).toFixed(
                    2,
                  )} kb`}</label>
                )}
              </div>
              <div className="pxy-1 radius-2 flex delete-widget h-fit-content cursor" onClick={() => setFile(null)}>
                <DeleteIcon width={14} height={14} />
              </div>
            </div>
          ) : (
            <div className="flex items-center mt-6 col-gap-4">
              <input
                className="display-none"
                type="file"
                ref={inputRef}
                onChange={e => {
                  const file = e.target.files[0];
                  onUpload(file);
                }}
              />
              <Button
                icon={uploadingImage ? <LoadingIcon height={14} /> : <Fragment />}
                label={'Upload file'}
                size="medium"
                borderRadius="12px"
                className="primary-white flex-1"
                onClick={() => !uploadingImage && inputRef.current.click()}
              />
              <label className="flex-1 regular-text font-12">PDF</label>
            </div>
          )}
          <div className="flex">
            <Button
              {...{
                label: 'Save',
                size: 'medium',
                borderRadius: '8px',
                className: 'primary mt-6',
                width: '100px',
              }}
              disabled={!selectedProduct || !file}
              onClick={() => onSave()}
            />
          </div>
        </div>
        <div className="flex-1"></div>
      </div>
    </ProductMediaWrapper>
  );
};

const ProductMediaWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 48px;

  .scroll-text {
    overflow-y: scroll;
    max-height: 600px;
  }
`;

export default ProductMedia;
